// @ts-nocheck
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import CloseIcon from '@mui/icons-material/Close';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SocialMediaGroup from 'components/SocialMediaGroup/index';
import Loader from 'components/uielements/Loader';
import { useAuth } from 'utils/customHooks/auth';
import NooderaButton from 'components/NooderaButton/index';
import { ReactComponent as ExploreSearchIcon } from 'assets/svg/explore_search.svg';
import { ReactComponent as GrayDoorIcon } from 'assets/svg/gray_door.svg';
import { ReactComponent as LogoSvg } from 'assets/images/isotype.svg';
import CoachSvg from 'assets/images/coach.svg';
import SchoolSvg from 'assets/images/school.svg';
import {
  AuthButtons,
  ContainerCloseExplore,
  ContainerExplore,
  FullNameProfile,
  HamburgerMenuClose,
  StyledLogout,
  StyledSeparator,
  StyledSvgLogoutWrapper,
  StyledExternalLinksList,
  ExternalLink,
} from 'components/HamburgerMenu/HamburgerMenu.style';
import defaultUserImage from 'assets/images/user-placeholder.png';
import updatePersonalInfoImage from 'assets/images/update-personal-info.svg';

import { fullName } from 'utils/user/name';
import { accessibilityConstants } from 'commons/constants/general';
import SvgImageWrapper from 'components/SvgImage/SvgImage.style';
import {
  ContainerSocialMediaGroup,
  TitleSocialMediaGroup,
} from 'components/SocialMediaGroup/SocialMediaGroup.styles';
// noinspection ES6PreferShortImport
import { getAppSettings, isNonNoodleInstance } from 'utils/privateLabel/index';
import { devConfig } from 'settings';
import { UTM_VALUES } from 'utils/heap';
import { getSessionStorageData } from 'utils/sessionStorage';
import { redirectWithUtmQueryStrings } from 'utils/urls';
import { Link } from 'react-router-dom';

const ExploreMenu = React.lazy(() => import('./ExploreMenu'));

export type MenuProps = {
  open: boolean;
  triggerAnimation: boolean;
  onMenuClose: (...args: Array<any>) => any;
};

const Menu: React.FC<MenuProps> = ({ open, triggerAnimation, onMenuClose }) => {
  const history = useHistory();
  const { logout } = useAuth();
  const isLoggedIn = useSelector((state: any) => state.auth.isLoggedIn);
  const { avatar: userAvatar = '' } = useSelector((state: any) => state.user || {});
  const { profile } = useSelector((state) => state.user);
  const { data: globalPartner } = useSelector((state) => state.partnerInstance.globalPartner);

  const appSettings = getAppSettings();
  const [exploreMenuOpen, setExploreMenuOpen] = React.useState(false);
  const utmParams: Record<string, string> = getSessionStorageData(UTM_VALUES);

  React.useEffect(() => {
    if (!open) {
      setExploreMenuOpen(false);
    }
  }, [open]);
  const animation = open ? 'slide-in-right' : 'slide-out-right';

  const renderBottomSection = (): React.ReactElement =>
    isLoggedIn ? (
      <div className='hamburger-menu__footer__container'>
        <div className='hamburger-menu__footer__text-container'>
          <a className='hamburger-menu__nav-links__user' href={(e) => e.preventDefault()}>
            <img
              className='hamburger-menu__user-avatar'
              src={userAvatar || defaultUserImage}
              alt=''
              loading='lazy'
              width='100%'
              height='100%'
            />
            <FullNameProfile>{fullName(profile)}</FullNameProfile>
          </a>
          <Link
            to={{
              pathname: '/update-personal-information',
              state: {
                prevPath: window.location.pathname,
              },
            }}
            className='hamburger-menu__nav-links__user'
            onClick={() => history.push('/update-personal-information')}
            type='button'
            tabIndex={-1}
          >
            <img
              className='hamburger-menu__user-avatar'
              src={updatePersonalInfoImage}
              alt=''
              loading='lazy'
              width='100%'
              height='100%'
            />
            <FullNameProfile>Update Profile Information</FullNameProfile>
          </Link>
          <button
            className='hamburger-menu__nav-links__action'
            onClick={() => logout({ partnerId: globalPartner?.partnerId })}
            type='button'
            tabIndex={-1}
          >
            <StyledLogout>Log Out </StyledLogout>
            <StyledSvgLogoutWrapper className='icon'>
              <GrayDoorIcon />
            </StyledSvgLogoutWrapper>
          </button>
        </div>
      </div>
    ) : (
      <div className='hamburger-menu__footer__container'>
        <div className='hamburger-menu__footer__text-container'>
          <h4 className='hamburger-menu__footer__title'>
            {(appSettings || globalPartner)?.companyName} is all about you!
          </h4>
          <span className='hamburger-menu__footer__text'>
            You need to create a profile to see your tailored content.
          </span>
        </div>
        <AuthButtons>
          <NooderaButton
            size='medium'
            tabIndex={0}
            aria-label='Log in'
            onClick={() =>
              devConfig.partnerId
                ? history.push('/login')
                : redirectWithUtmQueryStrings(`${globalPartner.frontDomain}/login`, utmParams)
            }
          >
            Log In
          </NooderaButton>
          {!isNonNoodleInstance ? (
            <NooderaButton.CTA
              size='medium'
              tabIndex={0}
              aria-label='Sign Up'
              onClick={() =>
                devConfig.partnerId
                  ? history.push('/login')
                  : redirectWithUtmQueryStrings(`${globalPartner.frontDomain}/signup`, utmParams)
              }
            >
              Sign Up
            </NooderaButton.CTA>
          ) : null}
        </AuthButtons>
      </div>
    );

  const renderExternalLinks = (): React.ReactElement =>
    !isLoggedIn && (
      <StyledExternalLinksList>
        <a href='https://highered.noodle.com/' target='_blank' rel='noreferrer'>
          <img src={SchoolSvg} alt='' />
          <span>For</span> Universities
        </a>
        <a href='https://employers.noodle.com/' target='_blank' rel='noreferrer'>
          <img src={CoachSvg} alt='' />
          <span>For</span> Employers
        </a>
        <ExternalLink href='https://about.noodle.com/' target='_blank' rel='noreferrer'>
          <LogoSvg />
          <span>About</span> Noodle
        </ExternalLink>
      </StyledExternalLinksList>
    );

  const renderExploreSection = (): React.ReactElement => (
    <ContainerExplore>
      <div
        onClick={() => setExploreMenuOpen(true)}
        className='hamburger-menu__subheader__container'
        onKeyPress={() => setExploreMenuOpen(true)}
        role='button'
        tabIndex={0}
        aria-haspopup='true'
        aria-expanded={exploreMenuOpen}
      >
        <div className='hamburger-menu__subheader__content'>
          <React.Suspense fallback={<Loader />}>
            <SvgImageWrapper color='white'>
              <ExploreSearchIcon />
            </SvgImageWrapper>
          </React.Suspense>
          <div className='hamburger-menu__subheader__content__text'>
            <p className='hamburger-menu__subheader__title'>Explore</p>
            <p className='hamburger-menu__subheader__subtitle'>
              Browse thousands of resources, organized by 90+ programs.
            </p>
          </div>
        </div>
        <div className='hamburger-menu__right-chevron'>
          <ChevronRightIcon />
        </div>
      </div>
    </ContainerExplore>
  );

  const renderSocialGroup = (): React.ReactElement => (
    <ContainerSocialMediaGroup flexDirection='column' alignItems='left'>
      <TitleSocialMediaGroup>Follow us</TitleSocialMediaGroup>
      <SocialMediaGroup icons={appSettings.socialMedia} />
    </ContainerSocialMediaGroup>
  );

  return (
    <div className={`animated hamburger-menu ${triggerAnimation ? animation : ''}`}>
      {exploreMenuOpen ? (
        <React.Suspense fallback={<Loader />}>
          <ExploreMenu />
          <ContainerCloseExplore>
            <HamburgerMenuClose
              role='button'
              onClick={onMenuClose}
              onKeyPress={onMenuClose}
              tabIndex={0}
              title={accessibilityConstants.closeMenu.title}
              aria-label={accessibilityConstants.closeMenu.ariaLabel}
            >
              <CloseIcon />
            </HamburgerMenuClose>
          </ContainerCloseExplore>
        </React.Suspense>
      ) : (
        <>
          <div className='hamburger-menu__header__container'>
            <h3 className='hamburger-menu__header__title'>Menu</h3>
            <HamburgerMenuClose
              role='button'
              onClick={onMenuClose}
              onKeyPress={onMenuClose}
              tabIndex={0}
              title={accessibilityConstants.closeMenu.title}
              aria-label={accessibilityConstants.closeMenu.title}
            >
              <CloseIcon />
            </HamburgerMenuClose>
          </div>
          <StyledSeparator />
          {renderBottomSection()}
          {!isNonNoodleInstance && (
            <>
              {renderExploreSection()}
              <StyledSeparator />
            </>
          )}
          {renderExternalLinks()}
          {appSettings?.socialMedia && renderSocialGroup()}
        </>
      )}
    </div>
  );
};

export default Menu;
